export default __webpack_public_path__ + "./images/author.d7269386.svg";